import { Outlet } from "react-router-dom";

const DealParentPage = () => {
    return <Outlet />
}
export default DealParentPage;
